import { render, staticRenderFns } from "./StallOrders.vue?vue&type=template&id=1fd5c136&scoped=true"
import script from "./StallOrders.vue?vue&type=script&lang=js"
export * from "./StallOrders.vue?vue&type=script&lang=js"
import style0 from "./StallOrders.vue?vue&type=style&index=0&id=1fd5c136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd5c136",
  null
  
)

export default component.exports